<template>
  <div>
    <div class="select-full-page">
      <div class="container">
        <div class="top-info">
          <div @click="$emit('close')">
            {{ $t('myday.cancel') }}
          </div>
          <span>{{ `${$t('form.select')} ${$t('form.' + title)}` }}</span>
        </div>
        <input
          v-show="search"
          v-model="searchQuery"
          class="query"
          name="query"
          :placeholder="$t('form.search')"
        >
        <SelectFullScreenComp
          :data="data"
          :filter-key="searchQuery"
          :type_list="type_list"
          :multiple="multiple"
          :search-input="search"
          :title="title"
          :defaultSelected="defaultSelected"
          :hideValue="hideValue"
          @data-selected="emitSelectedData($event)"
          @validate="[$emit('validate'), $emit('close')]"
        />
        <button
          v-show="multiple"
          style="user-select: none"
          class="form-generator-button btn-custom"
          type="button"
          @click="[$emit('validate'), $emit('close')]"
        >
          {{ $t('form.validate') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectFullScreenComp from '@/components/GenericComponents/Form/SelectFullScreenComp.vue'

export default {
  components: {
    SelectFullScreenComp
  },
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    type_list: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultSelected: {
      type: Array,
      default: () => []
    },
    hideValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['validate', 'close', 'dataSelected'],
  data() {
    return {
      searchQuery: ''
    }
  },
  computed: {
    multiple() {
      return this.type_list === 'multiple'
    }
  },
  methods: {
    emitSelectedData(value) {
      // Close the modal and emit value if there are not several selectable
      if (!this.multiple) {
        this.$emit('close')
      }
      this.$emit('dataSelected', value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .select-full-page {
    position: fixed;
    inset: 0;
    z-index: 200;
    background-color: #fff;

    .container {
      padding: 1rem;

      /* Landscape screens */
      @media only screen and (orientation: landscape) {
        max-width: 1000px;
        margin: auto;
      }

      > form {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .top-info {
        margin-bottom: 7px;

        > div {
          position: absolute;
          width: 60px;
          z-index: 40;
          left: 20px;
          padding: 6px 6px 5px 0;
        }

        > span {
          width: 100%;
          font-size: 1.2rem !important;
          text-align: center;
          display: block;
          padding: 0 63px;
          line-height: 18px;
        }
      }
    }

    .query {
      border: 1px solid #b6b6b6;
      font-size: 0.9rem !important;
      -webkit-appearance: none;
      appearance: none;
      width: 100%;
      height: 33px;
      padding-left: 7px;
    }
  }
</style>
